module.exports = __webpack_public_path__ + "img/en-1-3.1fca7890.png";